export default "__VITE_PUBLIC_ASSET__5290646f__"